/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import Dots from '../../../components/Loading/Dots';
import { GET_ADMIN_PARTNER_STATISTICS } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import ArrowdownIcon from '../../../svgs/ArrowdownIcon';
import ArrowupIcon from '../../../svgs/ArrowupIcon';
import Styles from './PartnerTrackingDashboard.module.scss';

const PartnerTrackingDashboard = () => {
  const [
    getAdminPartnerStatistics,
    partnerStatisticsLoading,
    partnerMiniStatistics,
  ] = useCustomQuery({
    query: GET_ADMIN_PARTNER_STATISTICS,
    onError: () => {},
    onData: () => {},
  });

  const dashboardDetails = partnerMiniStatistics?.getAdminPartnerStatistic?.data;

  console.log('partnerStatisticsLoading', partnerStatisticsLoading);

  const details = [
    {
      id: 1,
      title: 'Total partners',
      count: dashboardDetails?.partners || 0,
      isIncrease: !(dashboardDetails?.totalPartnersPercentageChange < 0),
      time: 'last month',
      percentage: dashboardDetails?.totalPartnersPercentageChange || 0,
    },
    {
      id: 2,
      title: 'Total Referred Users',
      count: dashboardDetails?.totalReferredUsers || 0,
      isIncrease: !(dashboardDetails?.totalReferredUsersPercentageChange < 0),
      time: 'last month',
      percentage: dashboardDetails?.totalReferredUsersPercentageChange || 0,
    },
  ];

  useEffect(() => {
    getAdminPartnerStatistics();
  }, []);

  return (
    <div className={Styles.wrapper}>
      <div className="row">
        {details?.map((list) => (
          <div key={list?.id} className="col-md-6 col">
            {/* {partnerStatisticsLoading && <div className={Styles.wrapper__detailsLoader}><Dots /></div> } */}

            <div className={Styles.wrapper__container}>
              {partnerStatisticsLoading && (
                <div className={Styles.wrapper__loaderContainer}>
                  <div className={Styles.wrapper__detailsLoader}>
                    <Dots />
                  </div>
                </div>
              )}

              {!partnerStatisticsLoading && (
                <>
                  <div className={Styles.wrapper__title}>{list?.title}</div>
                  <div className={Styles.wrapper__count}>{list?.count}</div>

                  <div className={Styles.wrapper__stage}>
                    <span>
                      {list?.isIncrease ? <ArrowupIcon /> : <ArrowdownIcon />}
                    </span>
                    <span
                      className={
                        list?.isIncrease
                          ? Styles.wrapper__arrowUp
                          : Styles.wrapper__arrowDown
                      }
                    >
                      {`${list?.percentage}%`}
                    </span>

                    <span className={Styles.wrapper__time}>
                      vs
                      {' '}
                      {list?.time}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerTrackingDashboard;
